import React from 'react';
import {observer} from "mobx-react";
import {ExpandComponentProps} from "core/grid/component/gridComp";
import {action, ObservableMap} from "mobx";
import mdEntityService from "core/metamodel/mdEntityService";
import MdEntity from "core/metamodel/mdEntity";
import {GridRow} from "core/grid/domain/grid";
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/mergeMap';
import {PartyActivity} from "core/event/eventDomain";
import eventService from "core/event/eventService";
import styled from "styled-components";
import {ActivityBlock} from "core/event/component/taskActivityBlocks";

const itemStream = new Subject<any>();
itemStream
  .mergeMap((item) => Promise.all([item, eventService.readPartyActivity(item.rowId as number), mdEntityService.fetchEntities(["PartyActivity"])]), null, 5)
  .subscribe(action("subscribe-actionCb", ([item, activity, entityMap]: [GridRow, PartyActivity, ObservableMap<MdEntity>]) => {
   item.rowObject = activity;
   item.expanded = 2;
   console.log("ActivityExpando resolved activity %s", activity.partyActivityId);
}));


const MDiv = styled.div`
  margin-left: 24px;
`;

@observer
export default class ActivityExpando extends React.Component<ExpandComponentProps, null> {


  componentDidMount() {
    let {item} = this.props;
    const activity = item.rowObject as PartyActivity;
    if (!activity) {
      itemStream.next(item);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let {item} = this.props;
    const activity = item.rowObject as PartyActivity;
    if (!activity && prevProps.item.rowId !== item.rowId ) {
      itemStream.next(item);
    }
  }



  render() {
    let {item} = this.props;
    const activity = item.rowObject as PartyActivity;

    console.log("ActivityExpando render vehicle %s, expanded = %s", (activity)?activity.partyActivityId:null, item.expanded);

    if (item.expanded === 1) {
      return (
        <MDiv><i className="fa fa-refresh fa-2x fa-spin color-blue-grey-200"/></MDiv>
      );
    }

    return <ActivityBlock activity={activity}/>;
  }

}




// WEBPACK FOOTER //
// ./src/core/event/component/activityExpando.tsx